
import EditButton from '@/components/buttons/EditButton.vue'
import GenericTable from '@/components/GenericTable.vue'
import FormTitle from '@/components/processing_steps/FormTitle.vue'
import { BvTableFieldArrayWithStickColumn } from '@/types/base'
import { Vue, Component } from 'vue-property-decorator'
import BreadcrumbHeader from '@/components/processing_steps/BreadcrumbHeader.vue'

@Component({
  components: {
    GenericTable,
    EditButton,
    BreadcrumbHeader,
    FormTitle
  }
})
export default class ShowcaseTemplatesTable extends Vue {
  apiUrl = "/api/v4/showcase-templates/"
  createViewUrl = ""

  get breadcrumbs () {
    return [
      {
        title: this.$gettext('Funding page templates'),
        url: '#',
        icon: 'fundingScopeIcon'
      }
    ]
  }

  fields: BvTableFieldArrayWithStickColumn = [
    { key: 'title', label: this.$gettext('Page title'), sortable: true },
    {
      key: 'category',
      label: this.$gettext('Category'),
      sortable: true,
      formatter: (category) => {
        return this.categoryFormatter(category)
      }
    },
    { key: 'fixed_action_col', label: this.$gettext('Actions') }
  ]

  categoryFormatter (category: 1 | 2 | 3) {
    switch (category) {
      case 1:
        return this.$gettext('Promotion recommendation')
      case 2:
        return this.$gettext('Funding request')
      case 3:
        return this.$gettext('Funding result')
      default:
        return category
    }
  }

  editUrl (id: number) {
    return `/site-admin/showcase-templates/${id}/update/`
  }

  gotoCreateShowcaseTemplate () {
    window.location.href = "/site-admin/showcase-templates/create/"
  }
}
